/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {UpdateCustomNameRequest} from "../model/update-custom-name-request";

@Injectable({
    providedIn: "root",
})
export class SimCustomNameService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public updateCustomName(request: UpdateCustomNameRequest) {
        return super.post<boolean>(`/api/CustomName/UpdateCustomName`, request);
    }
}